"use client";

import { ReactNode } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { ListItemButton } from "@mui/material";

const CustomListItem = ({
  href,
  children,
}: {
  href: string;
  children: ReactNode;
}) => {
  const pathname = usePathname();
  const bgHoverColor =
    pathname === href ? "hover:bg-primary-900" : "hover:bg-neutral-50/20";
  return (
    <ListItemButton
      component={Link}
      href={href}
      selected={pathname === href}
      disableGutters
      className={bgHoverColor}
    >
      {children}
    </ListItemButton>
  );
};

export default CustomListItem;
